module.exports = __webpack_public_path__ + "img/discord03.11cac3c.jpg";